import { useState } from "react";
import { Button, ButtonProps } from "react-bootstrap";

import ConfirmationModal from "./ConfirmationModal";

interface GuardedButtonProps extends ButtonProps {
  confirmationMessage: string | React.ReactNode;
  showConfirmationMessage?: boolean;
}

const GuardedButton = (props: GuardedButtonProps) => {
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  const forwardedProps = { ...props };
  delete forwardedProps.confirmationMessage;
  delete forwardedProps.showConfirmationMessage;

  const showConfirmationMessage =
    props.showConfirmationMessage === undefined
      ? true
      : props.showConfirmationMessage;

  return (
    <>
      <ConfirmationModal
        show={showConfirmationModal}
        onCancel={() => setShowConfirmationModal(false)}
        onConfirm={(e) => {
          setShowConfirmationModal(false);
          props.onClick?.(e);
        }}
      >
        {props.confirmationMessage}
      </ConfirmationModal>
      <Button
        as="button"
        {...forwardedProps}
        onClick={(e) =>
          showConfirmationMessage
            ? setShowConfirmationModal(true)
            : props.onClick?.(e)
        }
      />
    </>
  );
};

export default GuardedButton;
